module.exports = __webpack_public_path__ + "media/evasgo_1.4c759103.wav";